import React from 'react';

const LISTING_BADGES = {
  service: { label: 'Service' },
  subscription: { label: 'Subscription' },
  crowdfund: { label: 'Crowdfund' },
  divispend: { label: 'DiviSpend' },
  offer: { label: 'Make Offer' },
  tip_jar: { label: 'Tip Jar' },
  digital_download: { label: 'Download' },
  booking: { label: 'Booking' },
};

export function ListingTypeBadge({ product }) {
  const lt = product.listing_type || (product.is_crowdfund ? 'crowdfund' : product.investment_enabled ? 'divispend' : null);
  const badge = lt ? LISTING_BADGES[lt] : null;
  if (!badge) return null;
  return (
    <span
      className="text-xs px-3 py-1 rounded-sm font-semibold flex items-center gap-1"
      style={{ backgroundColor: '#22C55E15', color: '#22C55E' }}
      data-testid={`listing-badge-${lt}`}
    >
      {badge.label}
    </span>
  );
}
